import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";
import { AsyncThunkOptionType } from "Reducers/types";

import { DeleteCertificateProps } from "../";
import { deleteCertificateRequest } from "Api/certificate/deleteCertificate.request";
import type { Certificate } from "Api/certificate/types";

/**
 * Delete one Certificate
 *
 * @param {string} organizationDescriptionId
 * @param {string} projectDescriptionId
 * @param {object} certificate
 *
 */

export const deleteCertificate = createAsyncThunk<
  Certificate,
  DeleteCertificateProps,
  AsyncThunkOptionType
>(
  "app/projectCertificate/delete_certificate",
  async (
    { organizationDescriptionId, projectDescriptionId, certificate },
    { rejectWithValue }
  ) => {
    try {
      await deleteCertificateRequest(certificate);

      return certificate;
    } catch (err: unknown) {
      logger(err, {
        action: "deleteCertificate",
        organizationDescriptionId,
        projectDescriptionId,
        certificate
      });
      return rejectWithValue(err);
    }
  },
  {
    condition: ({ certificate }: DeleteCertificateProps): boolean =>
      !!certificate._links?.["#delete"]?.href
  }
);
